import React, { useState } from 'react';
import { usePrices, Prices } from '../contexts/PriceContext';
import { ArrowLeftIcon, SaveIcon, RefreshCwIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function PriceConfig() {
  const {
    prices,
    updatePrices,
    resetPrices
  } = usePrices();
  const [formPrices, setFormPrices] = useState<Prices>({
    ...prices
  });
  const [saveMessage, setSaveMessage] = useState('');
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    const numValue = parseFloat(value);
    setFormPrices({
      ...formPrices,
      [name]: isNaN(numValue) ? 0 : numValue
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    updatePrices(formPrices);
    setSaveMessage('Prices updated successfully!');
    setTimeout(() => setSaveMessage(''), 3000);
  };
  const handleReset = () => {
    resetPrices();
    setFormPrices({
      ...defaultPrices
    });
    setSaveMessage('Prices reset to defaults!');
    setTimeout(() => setSaveMessage(''), 3000);
  };
  // Default prices for reference
  const defaultPrices: Prices = {
    gen3Body: 700,
    gen3Head: 425,
    gen3JudgesOnly: 350,
    fullGen3Ring: 900,
    technician: 500,
    taxRate: 0.09
  };
  return <div className="min-h-screen bg-slate-100" data-id="element-1489">
      <div className="bg-white shadow-sm border-b border-slate-200" data-id="element-1490">
        <div className="max-w-6xl mx-auto px-6 py-4 flex justify-between items-center" data-id="element-1491">
          <div className="text-xl font-bold text-blue-800" data-id="element-1492">
            Price Configuration
          </div>
          <Link to="/" className="flex items-center text-blue-600 hover:text-blue-800" data-id="element-1493">
            <ArrowLeftIcon size={16} className="mr-1" data-id="element-1494" />
            Back to Rental Form
          </Link>
        </div>
      </div>
      <div className="max-w-2xl mx-auto p-6" data-id="element-1495">
        <div className="bg-white p-6 rounded-lg shadow-md mt-8" data-id="element-1496">
          <h2 className="text-xl font-semibold mb-6 text-blue-800" data-id="element-1497">
            Update Rental Prices
          </h2>
          {saveMessage && <div className="mb-4 p-3 bg-green-100 text-green-700 rounded-md" data-id="element-1498">
              {saveMessage}
            </div>}
          <form onSubmit={handleSubmit} data-id="element-1499">
            <div className="space-y-4" data-id="element-1500">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1501">
                <div data-id="element-1502">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1503">
                    Gen 3 Body Price ($)
                  </label>
                  <input type="number" name="gen3Body" value={formPrices.gen3Body} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded-md" min="0" step="0.01" data-id="element-1504" />
                </div>
                <div data-id="element-1505">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1506">
                    Gen 3 Head Price ($)
                  </label>
                  <input type="number" name="gen3Head" value={formPrices.gen3Head} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded-md" min="0" step="0.01" data-id="element-1507" />
                </div>
                <div data-id="element-1508">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1509">
                    Gen 3 Judges Only Price ($)
                  </label>
                  <input type="number" name="gen3JudgesOnly" value={formPrices.gen3JudgesOnly} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded-md" min="0" step="0.01" data-id="element-1510" />
                </div>
                <div data-id="element-1511">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1512">
                    Full Gen 3 Ring Price ($)
                  </label>
                  <input type="number" name="fullGen3Ring" value={formPrices.fullGen3Ring} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded-md" min="0" step="0.01" data-id="element-1513" />
                </div>
                <div data-id="element-1514">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1515">
                    Technician Price ($)
                  </label>
                  <input type="number" name="technician" value={formPrices.technician} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded-md" min="0" step="0.01" data-id="element-1516" />
                </div>
                <div data-id="element-1517">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1518">
                    California Tax Rate (0-1)
                  </label>
                  <input type="number" name="taxRate" value={formPrices.taxRate} onChange={handleInputChange} className="w-full p-2 border border-gray-300 rounded-md" min="0" max="1" step="0.01" data-id="element-1519" />
                  <p className="text-xs text-gray-500 mt-1" data-id="element-1520">
                    Example: 0.09 for 9% tax rate
                  </p>
                </div>
              </div>
              <div className="flex justify-between pt-4 border-t border-gray-200 mt-6" data-id="element-1521">
                <button type="button" onClick={handleReset} className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" data-id="element-1522">
                  <RefreshCwIcon size={16} className="mr-2" data-id="element-1523" />
                  Reset to Defaults
                </button>
                <button type="submit" className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-1524">
                  <SaveIcon size={16} className="mr-2" data-id="element-1525" />
                  Save Changes
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>;
}